import { useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import StatusBadge from "cxfcomponents/StatusBadge";
import ProductCellfromUser from "layouts/pages/users/reports/components/Reviews/ProductCell";

import { setCredentialManagementShareAvaiableUsers } from "redux/actions/portal/credentialManagementActionCreator";

import DataTable from "cxfcomponents/Tables/DataTable";

import CheckboxShareTo from "./CheckboxShareTo";
import DropdownShareType from "./DropdownShareType";
import CredentialsDialogActions from "./CredentialsDialogActions";

const CredentialManagementShareUsersModal = () => {
  const {
    credentialManagementShareUsersModalOpen,
    credentialManangementShareAvailableUsers,
    selectedCredential
  } = useSelector((store) => store.portal.credentialManagement);
  const { users } = useSelector((store) => store.portal.users);
  const dispatch = useDispatch();

  const dataTableData = useMemo(() => {
    return {
      columns: [
        {
          Header: "Share to",
          accessor: "share_to",
          disableSortBy: true,
          disableGlobalFilter: true,
          Cell: ({ value }) => <CheckboxShareTo value={value} />
        },
        {
          Header: "users",
          accessor: "users",
          width: 500,
          disableSortBy: false,
          canGroupBy: false,
          disableGlobalFilter: true,
          defaultSortOrder: "desc"
        },
        {
          Header: "status",
          accessor: "status",
          Cell: ({ value }) => {
            return <StatusBadge status={value} />;
          },
          canGroupBy: false,
          disableGlobalFilter: true
        },
        {
          Header: "Share type",
          accessor: "share_type",
          disableSortBy: true,
          Cell: ({ value }) => <DropdownShareType value={value} />
        }
      ],
      rows: [
        ...(credentialManangementShareAvailableUsers?.map((user) => {
          return {
            share_to: user.auth0_id,
            users: (
              <ProductCellfromUser
                id={user.auth0_id}
                image={user.image}
                name={`${user.first_name} ${user.last_name}`}
                firstName={user.first_name}
                lastName={user.last_name}
                email={user.email_address}
                checked={true}
              />
            ),
            status: user?.status,
            share_type: user.auth0_id
          };
        }) ?? [])
      ]
    };
  }, [
    users,
    // selectedCredential,
    credentialManangementShareAvailableUsers
  ]);

  useEffect(() => {
    if (users && selectedCredential?.owner_id) {
      const shareToUsers =
        users.filter(
          (user) =>
            user.auth0_id !== selectedCredential?.owner_id &&
            !selectedCredential?.share_user?.some(
              (shareUser) => shareUser.user_id === user.auth0_id
            ) &&
            user.status === "active"
        ) || [];

      dispatch(setCredentialManagementShareAvaiableUsers(shareToUsers));
    }
  }, [users, selectedCredential]);

  return (
    <Dialog
      open={credentialManagementShareUsersModalOpen}
      fullWidth
      PaperProps={{
        style: {
          maxWidth: "1020px"
        }
      }}
    >
      <DialogTitle sx={{ marginLeft: "24px" }}>
        Share Credential: {selectedCredential?.application?.name}
      </DialogTitle>
      <DialogContent>
        <DataTable
          table={dataTableData}
          entriesPerPage={{ defaultValue: 25 }}
          splitted={true}
          isShareUnshareModal={true}
        />
      </DialogContent>
      <CredentialsDialogActions />
    </Dialog>
  );
};

export default CredentialManagementShareUsersModal;
